import {Box, Center} from '@chakra-ui/react';
import React from 'react';
import {GetStaticProps} from 'next';
import fs from 'fs'
import {join} from 'path'
import {components} from '../utils/markdownmapping';
import {NextSeo} from 'next-seo';
import {MDXRemote} from 'next-mdx-remote';
import {serialize} from 'next-mdx-remote/serialize';
import {getCollections} from '../utils/shop_backend';

// @ts-ignore collections prop used for header
const PrivacyPage = ({content, title, collections}) => {
    return <>
        <NextSeo
            title={title + ' - Blickfang'}
            openGraph={{
                type: 'website',
                locale: 'de_DE',
                title: title + ' - Blickfang',
                images: [{url: 'https://blckfng.com/images/full_page_image.jpg'}],
            }}
            twitter={{
                cardType: 'summary_large_image',
            }}
        />
        <Center p={'20px'}>
            <Box maxW={'900px'}>
                <MDXRemote components={components} {...content}/>
            </Box>
        </Center></>
}

export const getStaticProps: GetStaticProps = async (context) => {
    const collections = await getCollections();


    const name: string = context?.params?.mdpage as string;
    const path = join(process.cwd(), 'markdown', name + '.md')
    const fileContents = fs.readFileSync(path, 'utf8')
    const content = await serialize(fileContents)

    let title: string;

    switch (name) {
        case 'agbs':
            title = 'AGBs';
            break;
        default:
            title = name.charAt(0).toUpperCase() + name.slice(1);
    }

    return {
        props: {content, title, collections},
    }
}

export const getStaticPaths = async () => {
    const path = join(process.cwd(), 'markdown');
    const files = fs.readdirSync(path);
    return {
        paths:
            files.map(value => {
                return {'params': {'mdpage': value.replace('.md', '')}};
            }),
        fallback: false,
    }
};

export default PrivacyPage;
